<template>
    <NuxtLayout>
        <ShcUiFormPasswordReset
            :is-request-success="isRequestSuccess"
            :is-request-done="isRequestDone"
            @password-reset-request="resetPasswordRequest"
        />
    </NuxtLayout>
</template>

<script lang="ts" setup>
    import type { PasswordReset } from '@/components/Shc/Ui/Form/Password/Reset/formPasswordReset'

    const { $bus, $i18n } = useNuxtApp()
    const isRequestSuccess = ref(false)
    const isRequestDone = ref(false)
    const captchaToken = ref('')

    async function resetPasswordRequest(formData: PasswordReset) {
        $bus.$emit('customerRequestResetPassword', {
            ...formData,
            headers: {
                'X-ReCaptcha': captchaToken.value,
            },
        })
    }

    onMounted(async () => {
        const recaptcha = useCaptcha()

        captchaToken.value = await recaptcha('resetPassword')

        $bus.$on('customerError', async () => {
            captchaToken.value = await recaptcha('resetPassword')
        })
    })

    $bus.$on('customerRequestResetPasswordSuccess', () => {
        isRequestSuccess.value = true
    })

    $bus.$on('customerRequestResetPasswordDone', () => {
        isRequestDone.value = true
    })

    useHead({
        title: $i18n.t('Bbk.form.reset.heading'),
        meta: [
            {
                hid: 'robots',
                name: 'robots',
                content: 'noindex',
            },
        ],
    })
</script>
